// angular
// .module("HeroPRO")
// .controller("UploadIdController", uploadIdController);

import './uploadId.scss';

/* @ngInject */
export default function uploadIdController(AdvancedRegistrationFactory, $rootScope) {
    const vm = this;

    vm.uploaded = false;
    vm.isUploading = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    /* -----  End of Public Functions  ------*/


    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        $rootScope.$on('HPFileUploaded', onFileUpload);
    }

    function onFileUpload(ev, response, file) {
        vm.isUploading = true;
        AdvancedRegistrationFactory.commitIDUpload({
            ContractorUserId: AdvancedRegistrationFactory.getContractorUserId(),
            PhotoIDTempFileKey: file.tempFileKey,
            PhotoIDFileName: file.name,
            PhotoIDDocumentTypeId: 128,
            PersonIdentityId: AdvancedRegistrationFactory.getPersonIdentityId(),
        })
            .then(() => {
                vm.uploaded = true;
                vm.isUploading = false;
            });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/uploadId/uploadIdController.js